export default __webpack_public_path__ + "static/media/arras21.e6afbcd1.jpg";